import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {ElciaCard} from '../../../../components/card/card';

@Component({
  selector: 'elcia-call-statistic-card',
  imports: [ElciaCard],
  templateUrl: './call-statistic-card.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {class: 'block min-w-0'},
})
export class CallStatisticCard {
  label = input.required<string>();
  value = input.required<string>();
}
